
import React,{useState,useContext} from 'react'
import $ from "jquery";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import { AuthContextUser } from "../context/UserContext";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import '../student/ipc.css'
export const PanelStudent = () => {

    const { currentUser } = useContext(AuthContextUser);
    const { logOutUser } = useContext(AuthContextUser);
    const navigate = useNavigate();

  const closeSide = () =>{
    $("#mobileMenuOpen").click(function () {
        $("#mobileMenu").addClass("open");
        $("#adjusmentLayer").addClass("show");
    });
}

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);

const showPopup = () =>{
    handleShowb(true)
}

const [inputs, setInput] = useState({
    tel: "",
    password: "",
  });

const logOutUserRemove = () =>{
    logOutUser(inputs);
    navigate("/");
}

const [file, setfile] = useState("");
const handleFile = (e) => {
  setfile(e.target.files[0]);
};

const updateImageUser = async (meliUser) => {
    try {
      if (!file) {
        toast.warning("لطفا یک عکس انتخاب کنید");
      } else {
        const formdata = new FormData();
        formdata.append("image", file);
        axios
          .put(
            `https://clinic.salamatpayanew.ir/StudentUpdate/UpdateUsersImage/${currentUser.tel}`,
            formdata
          )
          .then((res) => {
            toast.success(
              "عکس با موفقیت بارگذاری شد - پس از تایید مدیر قابل نمایش میباشد"
            );
          });
      }
    } catch (Err) {
      toast.error("خطا در ثبت عکس - لطفا دوباره سعی کنید");
    }
  };

if (currentUser.tel === null) {
    
} else {

  return (
    <>  
   <aside class="sidebar h-100 position-relative d-none d-md-block" dir='rtl'>

        <img src="../img/sidebar-auth-cover.png" 
            class="position-absolute right-0 left-0 m-auto top-0 w-100 d-none d-xl-block" 
            alt="" />

        <div class="auth-box-container m-auto d-none d-xl-block">
            <div>
            <div className="file-upload">
                <img src={currentUser.img} alt="" class="avatar" />
                <input type="file" onChange={handleFile} />
    </div>

            </div>
            <p class="text-center auth-name d-none d-xl-block">سمت : {currentUser.type}</p>
            <p class="text-center auth-role d-none d-xl-block">کاربر : {currentUser.name}</p>
            <p class="text-center auth-number d-none d-xl-block">{currentUser.tel}</p>
           <button
                class="custom-btn-primary power-button m-auto position-relative overflow-hidden h-auto d-flex justify-content-center align-items-center" onClick={logOutUserRemove}>
               <i class="zmdi zmdi-power text-white"></i>
                <div class="reple position-absolute"></div>
            </button>
        </div>
        <ul class="d-flex flex-column main-menu p-0">
            <img src="../img/Avatar-Image.png" alt="" width="58"
                class="d-block d-xl-none m-auto text-center mb-4 rounded-circle" />
            <li class="d-flex flex-column align-items-center justify-content-between w-100 color-primary">
                <Link to="/AssistantAdmin/DasheboardCard" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-primary"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-primary">داشبورد</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AssistantAdmin/SicknessPeriod" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">ثبت بیماران</p>
                    </div>
                </Link>
            </li>
        <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AssistantAdmin/MedicalCommand" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">مدیریت بیمار</p>
                    </div>
                </Link>
       </li>
       <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AssistantAdmin/folderold" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">پروندهای قدیم</p>
                    </div>
                </Link>
       </li>
       
       <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AssistantAdmin/onlineNobatAdd" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">ایجاد نوبت آنلاین</p>
                    </div>
                </Link>
       </li>
       <li class="d-flex align-items-center justify-content-between w-100 color-primary">
                <Link to="/AssistantAdmin/onlinelist" class="menu-active position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw"></i>
                        <p class="my-0 mx-3 d-none d-xl-block text-default">لیست نوبت آنلاین</p>
                    </div>
                </Link>
       </li>
            <li class="d-flex align-items-center justify-content-between w-100">
                <Link to="" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default d-none d-xl-block">تیکت پشتیبانی</p>
                    </div>
                </Link>
            </li>
        </ul>
    </aside>
    <aside class="mobile-sidebar" id="mobileMenu" dir='rtl'>
        <ul class="d-flex flex-column main-menu-responsive p-0">
            <div class="d-flex flex-column justify-content-between align-items-center">
                <img src="../img/logo.png" width="140" alt="" />
            </div>
            <div class="devider"></div>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AssistantAdmin/DasheboardCard" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-home text-primary"></i>
                        <p class="my-0 mx-3 text-default text-primary">داشبورد</p>
                    </div>
                </Link>
            </li>
            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AssistantAdmin/SicknessPeriod" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default">ثبت بیمار</p>
                    </div>
                </Link>
            </li>

            <li class="d-flex align-items-center justify-content-between w-100 menu-item">
                <Link to="/AssistantAdmin/MedicalCommand" class="position-relative w-100 menu-item-container">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="zmdi zmdi-hc-fw text-default"></i>
                        <p class="my-0 mx-3 text-default">مدیریت بیمار</p>
                    </div>
                </Link>
            </li>

        </ul>
    </aside>
    
    <div class="d-flex flex-column w-100" dir='rtl'>
      
        <div class="block-header d-flex d-md-none flex-row-reverse">
            <div class="d-flex justify-content-center align-items-center flex-row-reverse">
                <img src="../img/Avatar-Image.png" class="block-header-auth-img rounded-circle" alt="" />
                <button class="btn btn-icon mobile_menu mx-3" type="button"> <i
                        class="zmdi zmdi-settings mx-3"></i></button>
                <button class="btn btn-icon mobile_menu" type="button"> <i class="zmdi zmdi-power"></i></button>
            </div>
            <button class="btn btn-icon mobile_menu custom-bg-primary" type="button" onClick={closeSide} id="mobileMenuOpen"><i
                    class="zmdi zmdi-sort-amount-desc"></i></button>
        </div>
        <div class="d-none d-md-flex w-100">
            <div class="app-header-bar p-24 w-100">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="w-50 d-flex justify-content-start align-items-center w-auto">
                        <button
                            class="custom-btn-primary ml-16 app-header-botton-control position-relative w-auto px-1">
                            <span> دریافت
                                گزارش
                                کاربری</span>
                            <span class="app-header-botton-devider mx-2"></span>
                            <div href="#" class="app-header-botton-control-link">
                                <img src="../icons/exists icon arrow.svg" alt="" />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal show={showb} onHide={handleCloseb} className=''>
        <Modal.Body>
        <div id="Removemodal" tabindex="-1" role="dialog"
                                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header text-center border-0 p-0">
                                                <img src="../img/remove.png" class="m-auto" alt="" />
                                            </div>
                                            <div class="modal-body text-center border-0 p-0 border-end-0">
                                                <h3>مطمعنی میخوای حذف کنی</h3>
                                                <p class="t-16">شما درحال حذف کاربر میلاد اعرابها هستید . آیا حذف انجام
                                                    شود؟</p>
                                            </div>
                   
                                        </div>
                                    </div>
          </div>
        </Modal.Body>

        <div class="modal-footer flex-row-reverse border-0 w-100 justify-content-center p-0" dir='rtl'>
                <button type="button" class="btn custom-btn-secondary d-inline-block"
                   data-dismiss="modal">لغو</button>
                    <button type="button" class="btn custom-btn-danger d-inline-block">بله
                     حذف کن</button>
                  </div>

      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

    </>
  )
}
}
